import { render } from "./ApplicationMobilePatient.vue?vue&type=template&id=5860447e"
import script from "./ApplicationMobilePatient.vue?vue&type=script&lang=js"
export * from "./ApplicationMobilePatient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__